<div class="patient-map-wrapper">
  <!-- Painel lateral de filtros -->
  <div class="location-filters" [class.d-none]="!showFilters && isMobileView">
    <div class="filter-header">
      <h3>Filtrar Localizações</h3>
      <div class="filter-actions">
        <button (click)="toggleAllLocations(true)" class="filter-btn">Marcar todos</button>
        <button (click)="toggleAllLocations(false)" class="filter-btn">Desmarcar todos</button>
      </div>
    </div>
    
    <div class="search-box">
      <input 
        type="text" 
        placeholder="Buscar cidade ou estado..." 
        [(ngModel)]="searchTerm" 
        (input)="filterLocations()"
        class="search-input">
    </div>
    
    <div class="filter-stats">
      <span>{{ filteredLocationsList.length }} de {{ locationsList.length }} localizações</span>
      <div class="filter-hint">
        <small><i>Somente localizações marcadas serão exibidas no mapa</i></small>
      </div>
    </div>

    <div class="location-list">
      <div *ngIf="filteredLocationsList.length === 0" class="no-results">
        Nenhuma localização encontrada para "{{ searchTerm }}"
      </div>
      
      <div *ngFor="let loc of filteredLocationsList" class="location-item">
        <div class="location-checkbox">
          <input 
            type="checkbox" 
            [id]="'loc-' + loc.id" 
            [(ngModel)]="loc.visible" 
            (change)="updateVisibleLocations()">
          <label [for]="'loc-' + loc.id" class="location-label">
            <span class="location-name">{{ loc.name }}</span>
            <span class="location-count">{{ loc.count }}</span>
          </label>
        </div>
      </div>
      
      <!-- Espaço extra para garantir rolagem adequada -->
      <div class="extra-space"></div>
    </div>
    
    <!-- Botão para fechar no mobile (apenas visível em dispositivos móveis) -->
    <div class="bottom-button-container" *ngIf="isMobileView">
      <button (click)="toggleFiltersPanel()" class="close-filters-btn">
        Aplicar e Voltar ao Mapa
      </button>
    </div>
  </div>

  <div class="patient-map-container">
    <!-- Botão para mostrar/esconder filtros em telas pequenas -->
    <button class="toggle-filters-btn d-md-none" (click)="toggleFiltersPanel()">
      {{ showFilters ? 'Fechar Filtros' : 'Filtrar Mapa' }} 
      <span class="toggle-icon">{{ showFilters ? '✖' : '▼' }}</span>
    </button>
    
    <!-- Exibir loading quando estiver carregando -->
    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-message">Carregando dados do mapa...</div>
    </div>

    <!-- Exibir erro se ocorrer -->
    <div *ngIf="error && !isLoading" class="error-container">
      <div class="error-message">{{ error }}</div>
      <button (click)="recarregarDados()" class="retry-button">Tentar novamente</button>
    </div>

    <!-- Overlay apenas quando há localizações mas todas foram desmarcadas -->
    <div *ngIf="!isLoading && !error && locations.length > 0 && visibleLocations.length === 0" class="no-data-container">
      <div class="no-data-message">
        <p>Nenhuma localização visível no mapa.</p>
        <p>Marque pelo menos uma localização no painel de filtros.</p>
      </div>
      <button (click)="toggleAllLocations(true)" class="retry-button">Marcar todas</button>
    </div>

    <!-- Container do mapa -->
    <div id="map" class="map-container"></div>

    <!-- Legenda -->
    <div class="legend">
      <h4>Quantidade de Pacientes</h4>
      <div class="legend-item">
        <div class="marker-example" style="background-color: #f5f0ff; width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; display: flex; justify-content: center; align-items: center; color: #333; font-weight: bold; font-size: 9px;">&lt;10</div>
        <span>Menos de 10</span>
      </div>
      <div class="legend-item">
        <div class="marker-example" style="background-color: #d4c4eb; width: 26px; height: 26px; border-radius: 50%; border: 2px solid white; display: flex; justify-content: center; align-items: center; color: #333; font-weight: bold; font-size: 9px;">25</div>
        <span>10 - 50</span>
      </div>
      <div class="legend-item">
        <div class="marker-example" style="background-color: #b99de0; width: 30px; height: 30px; border-radius: 50%; border: 2px solid white; display: flex; justify-content: center; align-items: center; color: white; font-weight: bold; font-size: 9px;">75</div>
        <span>51 - 100</span>
      </div>
      <div class="legend-item">
        <div class="marker-example" style="background-color: #9e76d6; width: 34px; height: 34px; border-radius: 50%; border: 2px solid white; display: flex; justify-content: center; align-items: center; color: white; font-weight: bold; font-size: 9px;">300</div>
        <span>101 - 500</span>
      </div>
      <div class="legend-item">
        <div class="marker-example" style="background-color: #8350cc; width: 38px; height: 38px; border-radius: 50%; border: 2px solid white; display: flex; justify-content: center; align-items: center; color: white; font-weight: bold; font-size: 8px;">750</div>
        <span>501 - 1000</span>
      </div>
      <div class="legend-item">
        <div class="marker-example" style="background-color: #6b3fa8; width: 42px; height: 42px; border-radius: 50%; border: 2px solid white; display: flex; justify-content: center; align-items: center; color: white; font-weight: bold; font-size: 8px;">1K+</div>
        <span>1000+</span>
      </div>
      <div class="legend-note">
        <small><i>💡 Clique em qualquer marcador para ver detalhes</i></small>
        <small><i>🔍 Grupos mostram total de pacientes agrupados</i></small>
      </div>
    </div>
  </div>
</div> 